<template>
<div id="secure">

    <TopMenu />
    <section class="main-content columns is-fullheight">
        <div class="container column is-12">
            <div class="section">
                <a class="button is-info is-outlined" v-on:click="goTutorial()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-youtube-play"></i></span> Tutorial
                </a>
                <a class="button is-info is-outlined" v-on:click="getHelp()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-question-circle"></i></span> Help
                </a>
                <a class="button is-info" href="https://www.studentqr.com/download" target="_blank" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-cloud-download"></i></span> Download App
                </a>
                <div class="card">
                    <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
                        <ul>
                            <li><a v-on:click="goDbGroup()">Groups</a></li>
                            <li style="padding-left: 5px; padding-right: 5px;">{{ groupName }}</li>
                            <li class="is-active"><a href="#" aria-current="page">Manage Students</a></li>
                        </ul>
                    </nav>
                    <!-- <div class="card-header"><a class="button is-info header-button" v-on:click="goClassDashboardSingle()">{{ kelasName }}</a> <span class="header-tag">Manage Students</span></div> -->
                </div><br/>
                    
                <div class="columns">
                    <div class="column one-half">
                        <div class="card">
                            <loading :active.sync="isLoading1" 
                                :can-cancel="false" 
                                :is-full-page="false">
                            </loading>
                            <div class="card-header">
                                <p class="card-header-title">Take Students Into This Group</p>
                            </div>
                        </div>
                        <div style="padding: 5px;">
                            <div class="columns">
                                <div class="column is-four-fifths">                                        
                                    <multiselect v-model="selectedStudentsToImport" :options="studentsToImport" :close-on-select="false" :multiple="true" :hide-selected="true" label="nameWithKelas" track-by="name" placeholder="Select students to bring into this group"></multiselect>
                                </div>
                                <div class="column is-one-fifth"><button class='button is-info' v-on:click="takeStudents()">Take Students Now</button></div>
                            </div>
                        </div>
                        <br />

                        <div class="card">
                            <loading :active.sync="isLoading2" 
                                :can-cancel="false" 
                                :is-full-page="false">
                            </loading>
                            <div class="card-header">
                                <p class="card-header-title">Students</p>
                                <a class="button is-primary" v-on:click="importStudentForm()" style="margin: 5px;" v-show="!importStudent">Import Students from Excel</a>
                                <a class="button is-warning" v-on:click="closeImportStudentForm()" style="margin: 5px;" v-show="importStudent">Close Import Students</a>
                            </div>
                            <div class="card-content">

                                <div class="content" v-show="importStudent">                                    
                                    <import-students :groupID="groupID"></import-students>
                                </div>

                                <div class="content">
                                    <div class="columns bottom-border">
                                        <div class="column">Name</div>
                                        <div class="column is-2">&nbsp;</div>
                                    </div>
                                    <student-list v-bind:studentList="studentList"></student-list>
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
                

            </div>
        </div>

    </section>    
</div>
</template>

<script>
import TopMenu from '../../TopMenu'
import ImportStudents from '../Group/ImportStudents';
import StudentList from '../Group/StudentList';
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import Multiselect from 'vue-multiselect'
import VueSweetalert2 from 'vue-sweetalert2';

export default {
    name: "GroupManageStudents",
    components: {
        TopMenu,
        Loading,
        StudentList,
        ImportStudents,
        Multiselect
    },
    data() {
        return {
            input: {
                email: '',
                groupID: '',
                option1: '',
                studentID: '',
            },
            groupID: '',
            groupName: '',
            actionYear: 0,
            actionMonth: 0,
            actionDate: '',
            duration: 0,
            sortBy: 0,
            studentList: [],
            studentsToImport: [{
                _id: '',
                name: '',
                kelasID: '',
                kelasName: '',
            }],
            importStudent: false,    
            isLoading1: false,
            isLoading2: false,
            selectedStudentsToImport: [],
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    created() {
        var currentDate = new Date();
        var currentDay = currentDate.getDate();
        if (currentDate.getDate() < 10){
            currentDay = "0" + currentDay;
        }
        var currentMonth = currentDate.getMonth() + 1;  //since month starts from 0
        if (currentMonth < 10){
            currentMonth = "0" + currentMonth;
        }
        this.actionDate = currentDate.getFullYear() + "" + currentMonth + "" + currentDay;
        this.actionYear = currentDate.getFullYear()

        this.groupID = this.$store.getters.getViewGroupID;

        if (this.groupID.trim.length < 1){
            this.groupID = localStorage.getItem('VIEW_GROUP_ID')
        }

        this.groupName = this.$store.getters.getViewGroupName;

        if (this.groupName.trim.length < 1){
            this.groupName = localStorage.getItem('VIEW_GROUP_NAME')
        }
    },
    mounted(){
        this.getStudents()
        this.getStudentsToImport()
    },
    methods: {
        goTutorial(){
            window.open("https://www.studentqr.com/resources", '_blank');
        },
        getHelp(){            
            window.open("https://helpstudentqr.wasap.my", '_blank');
        },
        importStudentForm(){
            this.importStudent = true;
        },
        closeImportStudentForm(){
            this.importStudent = false;
        },
        getStudents(){
            let self = this;
            self.isLoading2 = true;

            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/students/list', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        category: 'group',
                        groupID: self.groupID,
                    }
                })
                .then(response => {
                    self.studentList = []
                    self.studentList = response.data.students
                    self.isLoading2 = false;
                })
                .catch(e => {
                    console.log("234 Error:" + e)
                    self.isLoading2 = false;
                }) 
        },
        getStudentsToImport(){
            let self = this;
            self.isLoading1 = true;
            
            var show = 'all';

            if (self.duration == 0){
                show = 'all';
            }else{
                show = 'monthly'
                self.actionMonth = self.duration
            }

            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/students/list', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        category: 'schoolWithKelasDataAndNotInGroup',
                        groupID: self.groupID,
                    }
                })
                .then(response => {
                    self.studentsToImport = []
                    console.log("getStudentsToImport:")
                    for (var i = 0; i < response.data.length; i++){
                        var obj = {};
                        obj["_id"] = response.data[i]._id;
                        obj["name"] = response.data[i].firstName + " " + response.data[i].lastName;
                        obj["kelasID"] = response.data[i].kelasID._id;
                        obj["kelasName"] = response.data[i].kelasID.level + " " + response.data[i].kelasID.name;
                        obj["nameWithKelas"] = response.data[i].firstName + " " + response.data[i].lastName + " (" + response.data[i].kelasID.level + " " + response.data[i].kelasID.name + ")";
                        //obj["kelasID"] = response.data[i].firstName + " " + response.data[i].lastName;
                        self.studentsToImport.push(obj);
                    }
                    self.isLoading1 = false;
                })
                .catch(e => {
                    console.log("234 Error:" + e)
                    self.isLoading1 = false;
                }) 
        },
        takeStudents(){
            if (this.selectedStudentsToImport.length < 1){
                this.$swal({
                    type: "error",
                    title: 'Please select the students you want to bring into this group',
                })
                return false;
            }

            let self = this;
            this.$swal({
                title: "Are you sure?",
                text: "Selected students will be taken into this group. Continue?",
                showCancelButton: true,
                confirmButtonText: 'Yes, take them in',
                cancelButtonText: 'No, cancel',
                showCloseButton: true
            }).then((result) => {
                if (result.value){
                    self.isLoading1 = true;
                    this.input.email = localStorage.getItem('email')
                    this.input.sessionID = localStorage.getItem('sessionID')
                    this.input.groupID = self.groupID

                    this.input.selectedStudentsToImport = this.selectedStudentsToImport;

                    axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                    axios.defaults.responseType = 'json'
                    axios.post(process.env.MY_URL + '/api/group/students/in', this.input)
                        .then(response => {
                            self.isLoading1 = false;

                            if (response.data.success == false) {
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 5000
                                })
                            } else {
                                self.getStudents();
                                Toast.open({
                                    message: response.data.msg,
                                    type: 'is-success',
                                    duration: 3000
                                })
            
                                this.selectedStudentsToImport = "";
                            }
                        })
                        .catch(e => {
                            if (e.response.status === 401) {
                                console.log("salah login")
                                this.errors.push("Invalid login")
                                Toast.open({
                                    message: "Unauthorized access. Please re-login.",
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 10000
                                })
                            } else {
                                this.errors.push(e)
                                Toast.open({
                                    message: e,
                                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                    duration: 10000
                                })
                            }
                        })
                }
            })
        },
        sortStudentsAndPoints(arrays){
            if (this.sortBy == 1){  //points
                return _.orderBy(arrays, 'tempNumber1', 'desc');  //we're using the magical lodash function here
            }else{  //name
                return _.orderBy(arrays, 'firstName', 'asc');  //we're using the magical lodash function here
            }            
        },
        goDbGroup(){
            this.$router.push({
                name: "DbGroupMain"
            });
        },
        goPositiveDetails(id,name){
            this.$store.commit('UPDATE_STUDENT_ID',id)
            this.$store.commit('UPDATE_STUDENT_NAME',name)
            localStorage.setItem('STUDENT_ID',id)
            localStorage.setItem('STUDENT_NAME',name)
            this.$router.push({
                name: "ClassPositiveDetails"
            });
        },
        goClassDashboard(){
            this.$router.push({
                name: "ClassDashboard"
            });
        },
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.kelas-button{
    margin-right: 10px;
    margin-bottom: 10px;
}
.header-tag{
    margin-left: 10px;
    border: 1px solid #209cee;
    color: #209cee;
    padding-bottom: calc(0.375em - 1px);
    padding-left: 0.75em;
    padding-right: 0.75em;
    padding-top: calc(0.375em - 1px);
    align-items: center;
    border-radius: 4px;
    font-size: 1rem;
    height: 2.25em;
    line-height: 1.5;
    margin: 10px;
}
.header-button{
    margin-top: 10px;
    margin-left: 10px;
}
.top-border{
    border-top: 1px solid #CCC
}
.right-border{
    border-right: 1px solid #CCC
}
.bottom-border{
    border-bottom: 1px solid #CCC
}
.text-center{
    text-align: center;
}
.header-input{
    margin: 10px;
}
.breadcrumb{
    padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Database/Group/ManageStudents.vue